import CajaLateral from './caja-lateral';
export default CajaLateral;